import { useState } from 'react';
import { createClient } from '../../../api/users.api';
import { buySubscription } from '../../../api/subscriptions.api';

export default function NewClientModal({ open, onClose, onSuccess }) {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    subscriptionType: 'academy',
    paymentStatus: 'completed',
  });

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  };

  const submit = async () => {
    if (!form.name.trim()) {
      return alert('نام اجباری است');
    }

    if (!form.email && !form.phoneNumber) {
      return alert('ایمیل یا شماره موبایل حداقل یکی لازم است');
    }

    try {
      // 1) ساخت کلاینت
      const res = await createClient({
        name: form.name,
        email: form.email,
        phoneNumber: form.phoneNumber,
        subscriptionType: form.subscriptionType,
        paymentStatus: form.paymentStatus,
      });

      const userId = res.data._id;

      // 2) فعالسازی اشتراک
      await buySubscription({
        userId,
        productType: form.subscriptionType,
      });

      alert('کاربر با موفقیت ایجاد شد');
      onSuccess?.();
      onClose();
    } catch (err) {
      console.error(err);
      alert('خطا در ایجاد کاربر');
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl">
        <h2 className="text-lg font-bold mb-4">افزودن مشتری جدید</h2>

        <div className="space-y-3">
          <input
            className="w-full border p-2 rounded"
            placeholder="نام"
            name="name"
            value={form.name}
            onChange={handleChange}
          />

          <input
            className="w-full border p-2 rounded"
            placeholder="ایمیل"
            name="email"
            value={form.email}
            onChange={handleChange}
          />

          <input
            className="w-full border p-2 rounded"
            placeholder="شماره موبایل"
            name="phoneNumber"
            value={form.phoneNumber}
            onChange={handleChange}
          />

          {/* Subscription type */}
          <div>
            <label className="text-sm mr-2">نوع اشتراک</label>
            <select
              name="subscriptionType"
              className="border p-2 rounded w-full"
              value={form.subscriptionType}
              onChange={handleChange}>
              <option value="academy">دوره آکادمی</option>
              <option value="pro">دوره تکمیلی</option>
              <option value="private">دوره خصوصی</option>
            </select>
          </div>

          {/* Payment status */}
          <div>
            <label className="text-sm mr-2">وضعیت پرداخت</label>
            <select
              name="paymentStatus"
              className="border p-2 rounded w-full"
              value={form.paymentStatus}
              onChange={handleChange}>
              <option value="completed">پرداخت شده</option>
              <option value="pending">معلق</option>
              <option value="partial">اقساط</option>
            </select>
          </div>
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 border rounded-xl hover:bg-gray-50">
            لغو
          </button>

          <button
            onClick={submit}
            className="px-4 py-2 bg-blue-600 text-white rounded-xl">
            ذخیره
          </button>
        </div>
      </div>
    </div>
  );
}
